import React from 'react';
import { cn } from '../utils/cn';
export const Toggle = React.forwardRef(function Toggle(
  {
    label,
    description,
    checked: controlledChecked,
    defaultChecked = false,
    onChange,
    disabled,
    className,
    id,
    ...props
  },
  ref,
) {
  const toggleId = id || React.useId();
  const [internalChecked, setInternalChecked] = React.useState(defaultChecked);
  const isControlled = controlledChecked !== undefined;
  const checked = isControlled ? controlledChecked : internalChecked;
  const handleClick = () => {
    if (disabled) return;
    const next = !checked;
    if (!isControlled) setInternalChecked(next);
    onChange?.(next);
  };
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <button
        ref={ref}
        id={toggleId}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={handleClick}
        className={cn(
          'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          checked ? 'bg-surface-inverse' : 'bg-neutral-200',
        )}
        {...props}
      >
        <span
          aria-hidden="true"
          className={cn(
            'pointer-events-none inline-block h-5 w-5 rounded-full bg-surface shadow-sm ring-0 transition-transform duration-200',
            checked ? 'translate-x-5' : 'translate-x-0',
          )}
        />
      </button>
      {(label || description) && (
        <div>
          {label && (
            <label
              htmlFor={toggleId}
              className="text-sm font-medium text-fg-secondary cursor-pointer"
              onClick={handleClick}
            >
              {label}
            </label>
          )}
          {description && <p className="text-sm text-fg-tertiary">{description}</p>}
        </div>
      )}
    </div>
  );
});
